import axios, { AxiosInstance } from 'axios';

export interface LoginRequest {
  username: string;
  password: string;
  turnstile_token?: string;
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
}

class AuthService {
  private api: AxiosInstance;
  private baseURL: string;

  constructor() {
    // Используем config.js или fallback на /api/v1/auth
    this.baseURL = (window as any).API_CONFIG?.AUTH_BASE || '/api/v1/auth';

    this.api = axios.create({
      baseURL: this.baseURL,
      timeout: 10000,
    });

    // Interceptor для автоматического добавления токена
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem('authToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });

    // Interceptor для обработки ошибок авторизации
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem('authToken');
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }
    );
  }

  async login(username: string, password: string, turnstile_token?: string): Promise<LoginResponse> {
    const response = await this.api.post<LoginResponse>('/login', {
      username,
      password,
      turnstile_token,
    });
    return response.data;
  }

  async logout(): Promise<void> {
    await this.api.post('/logout');
  }

  setAuthToken(token: string | null): void {
    if (token) {
      this.api.defaults.headers.Authorization = `Bearer ${token}`;
    } else {
      delete this.api.defaults.headers.Authorization;
    }
  }

  getToken(): string | null {
    return localStorage.getItem('authToken');
  }

  // Проверка валидности токена
  async validateToken(): Promise<boolean> {
    try {
      // Простой запрос к защищенному endpoint'у
      // Используем health check endpoint который есть в auth сервисе
      await this.api.get('/health');
      return true;
    } catch {
      return false;
    }
  }
}

export const authService = new AuthService();